import axios from "axios";
import secureLocalStorage from "react-secure-storage";

export const axiosInstance = axios.create({
  // baseURL: "http://192.168.0.112:8080/api/",

  // Demo
  baseURL: "https://demoapi.mindoraworld.com/api/",
});

axiosInstance.interceptors.request.use((config) => {
  const credential = secureLocalStorage.getItem("admin_credentials");
  if (credential?.token) {
    config.headers.Authorization = `Bearer ${credential.token}`;
  }
  return config;
});

const config = {
  // appUrl: "/",
  // apiurl: "http://192.168.0.112:8080/api/",
  // imageUrl: "http://192.168.0.112:8080/api/public/images/",

  // Demo
  appUrl: "/",
  apiurl: "https://demoapi.mindoraworld.com/api/",
  imageUrl: "https://demoapi.mindoraworld.com/api/public/images/",
};

export const checkLoginStatus = (credential) => {
  if (!credential || typeof credential !== "object") return true;
  return !credential.token || !credential.email;
};

export default config;
